import { useEffect } from "react";
import Select from "../../../components/Select/Select";
import Input from "../../../components/Input/Input";
import { AlphadigiTypeEnum, AvicamTypeEnum } from "../../../constants/readers-model";
import { getNestedValue, setNestedValue } from "../../../utils/object";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";

export function PartialFormAvicam({ configuration, setConfiguration, setEditablePort, ...props }) {

   useEffect(() => {
      setEditablePort(true);
      if (!configuration) {
         setConfiguration({
            type: AlphadigiTypeEnum.LPR,
            displayLed: {},
         });
      }
   }, []);

   function onChange(field, value) {
      const currentValue = getNestedValue(configuration, field);
      if (currentValue === value) return;
      setConfiguration(setNestedValue({ ...configuration }, field, value));
   }

   return (
      <div className="w-full grid grid-cols-2 gap-2.5">
         <Input
            name="user"
            id="user"
            labelText="Usuário"
            value={configuration?.user}
            onChange={({ target }) => onChange('user', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Input
            name="password"
            id="password"
            type="password"
            labelText="Senha"
            value={configuration?.password}
            onChange={({ target }) => onChange('password', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <Select
            labelText="Tipo"
            value={configuration?.type}
            onChange={({ target }) => onChange('type', target.value)}
            disabled={props.type === "consulta"}
            required={true}
            options={[
               { value: AvicamTypeEnum.FACIAL, text: 'Facial' },
               { value: AvicamTypeEnum.CAMERA_RF_22812_IP, text: 'Câmera RF 22812 IP' },
            ]}
         />
         <Input
            name="eventTimeout"
            id="eventTimeout"
            type="number"
            labelText="Timeout de Evento"
            tooltipVisible={true}
            tooltipText="Eventos registrados após esse tempo em segundos, serão ignorados. (0 = ignorar verificação)"
            value={configuration?.eventTimeout}
            onChange={({ target }) => onChange('eventTimeout', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <div className="w-full flex flex-row items-center justify-start gap-3.5">
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Leitora com Validação de Máscara`}
               onChange={(e) => onChange('userMaskValidation', e.target.checked)}
               selected={configuration?.userMaskValidation}
            />
            <ToggleButton
               style={{ width: 'fit-content', paddingTop: '15px' }}
               label={`Modo Online`}
               onChange={(e) => onChange('modoOnline', e.target.checked)}
               selected={configuration?.modoOnline}
            />
         </div>
      </div>
   );
}